import { i18n, inject, observer, pr, React, RouteComponentProps, ui, theme } from "aaa";
import { MessageScreen } from "components/common/MessageScreen";
import externalInterfaceStore, { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { GooglePayStore } from "./GooglePayStore";
import { InfoBoxWithBackground } from "components/common/InfoBoxWithBackground";
import { FormattedHTMLMessage } from "react-intl";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: GooglePayStore;
}

@inject("externalInterfaceStore")
@observer
export class GooglePaySuccess extends React.Component<IProps & i18n.InjectedIntlProps & RouteComponentProps<{}>, {}> {
    render() {
        const infoBoxColor = externalInterfaceStore.isGeorgeApp ? "white" : undefined;

        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                useWebVersion
                variant="success"
                title={this.props.store.approvalResponse?.approved ? undefined : ui.__("googlePay.success.title")}
                messageComponent={this.props.store.approvalResponse?.approved
                    ? ui.__("googlePay.success.message.alreadyApproved")
                    : <>
                        {externalInterfaceStore.isGeorgeApp ? ui.__("googlePay.success.message.app") : ui.__("googlePay.success.message.web")}
                        <InfoBoxWithBackground
                            className="list-align-left"
                            iconColor={infoBoxColor}
                            style={{ textAlign: "left", marginTop: theme.MARGIN_LARGE }}
                        >
                            <pr.P_16_CONTENT style={{ color: infoBoxColor }}>
                                <FormattedHTMLMessage id="googlePay.landingPage.infoBox" />
                            </pr.P_16_CONTENT>
                        </InfoBoxWithBackground>
                    </>
                }
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/googlePay/GooglePaySuccess.tsx